import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone, Globe } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useApp, telLink } from "@/context/AppContext";

const Navbar = () => {
  const { tr, toggleLang } = useApp();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [pathname]);

  const links = [
    { to: "/", label: tr.nav.home },
    { to: "/brands", label: tr.nav.brands },
    { to: "/categories", label: tr.nav.categories },
    { to: "/search", label: tr.nav.search },
    { to: "/fleet", label: tr.nav.fleet },
    { to: "/services", label: tr.nav.services },
    { to: "/about", label: tr.nav.about },
    { to: "/contact", label: tr.nav.contact },
  ];

  return (
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-colors duration-300 border-b ${
        scrolled ? "bg-[#050505]/90 backdrop-blur-xl border-[#27272a]" : "bg-transparent border-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo-link"><Logo /></Link>

        <div className="hidden lg:flex items-center gap-6">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to === "/" ? "home" : l.to.slice(1)}`}
              className={`text-sm font-medium transition-colors hover:text-[#EAB308] ${
                pathname === l.to ? "text-[#EAB308]" : "text-zinc-300"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={toggleLang}
            data-testid="language-switcher"
            className="flex items-center gap-1.5 text-sm font-bold text-white border border-[#27272a] hover:border-[#EAB308] px-3 py-2 transition-colors"
          >
            <Globe className="h-4 w-4" /> {tr.langLabel}
          </button>
          <Link
            to="/quotation"
            data-testid="nav-quote-button"
            className="hidden sm:inline-flex bg-[#EAB308] text-[#050505] font-bold text-sm px-5 py-2.5 uppercase tracking-wide hover:bg-[#ca8a04] transition-colors"
          >
            {tr.cta.quote}
          </Link>
          <button className="lg:hidden text-white p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden bg-[#050505] border-t border-[#27272a] px-6 py-4 space-y-1" data-testid="mobile-menu">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="block py-2.5 text-zinc-200 hover:text-[#EAB308]">
              {l.label}
            </Link>
          ))}
          <a href={telLink} className="flex items-center gap-2 py-2.5 text-[#EAB308] font-semibold">
            <Phone className="h-4 w-4" /> {tr.cta.call}
          </a>
          <Link to="/quotation" className="block text-center bg-[#EAB308] text-[#050505] font-bold px-5 py-3 mt-2 uppercase">
            {tr.cta.quote}
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
